import { render, staticRenderFns } from "./WelfareShoppingCart.vue?vue&type=template&id=4e36f52e&scoped=true"
import script from "./WelfareShoppingCart.vue?vue&type=script&lang=js"
export * from "./WelfareShoppingCart.vue?vue&type=script&lang=js"
import style0 from "./WelfareShoppingCart.vue?vue&type=style&index=0&id=4e36f52e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36f52e",
  null
  
)

export default component.exports